import React from 'react'
import Link from 'gatsby-link'
import './Header.css'

// NOTE: when use img source, you need to IMPORT in JSX, but not in css

// TRICK: shift + option + downarrow will copy the line of code

// NOTE: Scrolling animation & state, listen to scoll Event || This is to write
// STATEFUL component -> fromt const Header = ({set title}) => (<div></div>) to class Header extends Component {}


// https://share.getcloudapp.com/ApuEqL4b
// src={`../images/logo.svg`}
class Header extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      hasScroll: false,
    }
  }

  componentDidMount() {
    // listen to events
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset; // where the user scrolled, the positioning data

    if (scrollTop > 50) {
      this.setState({ hasScroll: true });
    } else {
      this.setState({ hasScroll: false });
    }
  }


  render(){
    return (
      <div className={ this.state.hasScroll ? 'Header HeaderScrolled' : 'Header'}>
        <div className="HeaderGroup">
          <Link to="/"><img src="https://p75.tr0.n0.cdn.getcloudapp.com/items/9ZuRJwAQ/07afec68-f67e-48dc-89c2-d6ee6d719598.svg?v=c3ba2c1096648b507106d50d2aa52226" width="50" /></Link>
          <Link to="/about">About</Link>
          <Link to="/experience">Experience</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/viola"><button>Click Me</button></Link>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js